







import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import LocationAccounts from '@/components/locations/LocationAccounts.vue';
import DashboardBreadcrumbs from '@/components/breadcrumbs/DashboardBreadcrumbs.vue';

@Component({
  components: {
    'dashboard-breadcrumbs': DashboardBreadcrumbs,
    'location-accounts': LocationAccounts
  }
})
export default class LocationAccountsView extends Vue {
  get locationId(): number {
    return Number(this.$route.params.locationId);
  }
}
